import { render } from "./DefaultDialog.vue?vue&type=template&id=4a06c748&scoped=true"
import script from "./DefaultDialog.vue?vue&type=script&lang=js"
export * from "./DefaultDialog.vue?vue&type=script&lang=js"

import "./DefaultDialog.vue?vue&type=style&index=0&id=4a06c748&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4a06c748"

export default script